/*eslint-disable no-useless-constructor */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Navigate } from 'react-router-dom';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import CookiesService from '../../shared/CookiesService';
import Authenticated from '../../shared/Authenticated';
import EnableIntegration from '../../shared/EnableIntegration';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import sidebarMenu from '../../configuration/SidebarNav';
import MemberSummary from '../../api/MemberSummary';
import '../commonstyle.scss';
import OutsideClickHandler from 'react-outside-click-handler';

class SideNavBar extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    logoutFlag: false,
    myProfileFlag: false,
    mySettingsFlag: false,
    expanded: false,
  };
  Logout = () => {
    //localStorage.clear();
    //Check API Integration status
    if (EnableIntegration.isAPIIntegrationEnabled())
      CookiesService.remove('loginToken', { path: '/' });
    Authenticated.logout(() => {
      this.setState({
        logoutFlag: true,
      });
    });
  };

  myProfile = () => {
    if (EnableIntegration.isAPIIntegrationEnabled())
      this.setState({ myProfileFlag: true });
    else {
      if (Authenticated.isAuthenticated())
        this.setState({
          myProfileFlag: true,
        });
    }
  };

  mySettings = () => {
    if (EnableIntegration.isAPIIntegrationEnabled())
      this.setState({ mySettingsFlag: true });
    else {
      if (Authenticated.isAuthenticated())
        this.setState({
          mySettingsFlag: true,
        });
    }
  };
  render() {
    const { logoutFlag, myProfileFlag, mySettingsFlag } = this.state;
    let menuCount = 0;
    if (mySettingsFlag) {
      return <Navigate to="/admin/settings" push={true}></Navigate>;
    }

    if (myProfileFlag) {
      return <Navigate to="/admin/myprofile" push={true}></Navigate>;
    }

    if (logoutFlag) {
      return <Navigate to="/admin/logout" push={true}></Navigate>;
    }
    if (MemberSummary.getSideMenuPermissions()) menuCount = 3;
    else menuCount = 4;

    console.log('menuCount: ', menuCount);

    return (
      <div>
        <OutsideClickHandler
          onOutsideClick={() => {
            this.setState({
              expanded: false,
            });
          }}
        >
          <SideNav
            onToggle={(expanded) => {
              this.setState({
                expanded: expanded,
              });
            }}
            expanded={this.state.expanded}
          >
            <SideNav.Toggle className="p-0" aria-label="send email" />
            <SideNav.Nav>
              {Authenticated.isAuthenticated() && (
                <NavItem className="nav-link mobile-view d-md-none d-xs-block">
                  <NavIcon>
                    <img
                      src={require('../../img/Identity-username.png')}
                      alt="User"
                    />
                  </NavIcon>
                  <NavText className="user-icon">
                    <h4>Dennis Brown</h4>
                    <p>
                      Member ID: <b>14234234</b>{' '}
                    </p>
                    <p>
                      DOB: <b>12/23/1969</b>{' '}
                    </p>
                  </NavText>
                </NavItem>
              )}
              {sidebarMenu.map(
                (menuItem) =>
                  menuItem.id <= menuCount && (
                    <LinkContainer key={menuItem.id} to={menuItem.route}>
                      <NavItem className="nav-link">
                        <NavIcon>{menuItem.menuImg1}</NavIcon>
                        <NavText>{menuItem.text}</NavText>
                      </NavItem>
                    </LinkContainer>
                  ),
              )}

              <NavItem className="nav-link mobile-view d-md-none d-xs-block border-top">
                <NavIcon></NavIcon>
                <NavText onClick={this.myProfile}> My Profile</NavText>
              </NavItem>
              <NavItem className="nav-link mobile-view d-md-none d-xs-block">
                <NavIcon></NavIcon>
                <NavText onClick={this.mySettings}> Settings</NavText>
              </NavItem>
              <NavItem className="nav-link mobile-view d-md-none d-xs-block">
                <NavIcon></NavIcon>
                <NavText onClick={this.Logout}> Logout</NavText>
              </NavItem>
            </SideNav.Nav>
          </SideNav>
        </OutsideClickHandler>
      </div>
    );
  }
}

export default SideNavBar;
